export default __webpack_public_path__ + "static/media/trusted_distributors.0318bcea.svg";